export const enum SignupPage {
  MAIL_SUBMIT,
  VERIFICATION,
  NAME_SURNAME,
  PASSWORD
}
